import { Table } from 'antd';

import { ATTACHMENT } from '@/utils/enum';
import LazyImageRender from '../LazyImageRender';

interface Props {
  record: any;
}
const HeroSongDataTable = ({ record }: Props) => {
  const dataColumn = [
    {
      title: 'Image Attachment',
      dataIndex: 'image_attachment_id',
      key: 'image_attachment_id',
      ellipsis: true,
      width: '10%',
      render: (text: any, record: any, index: any) => {
        return <LazyImageRender id={text} attachmentType={ATTACHMENT.IMAGE} />;
      },
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      ellipsis: true,
      width: '10%',
      render: (text: any, record: any, index: any) => {
        return <div>{text}</div>;
      },
    },
    {
      title: 'Subtitle',
      dataIndex: 'subtitle',
      key: 'subtitle',
      ellipsis: true,
      width: '10%',
      render: (text: any, record: any, index: any) => {
        return <div>{text}</div>;
      },
    },

    {
      title: 'Song Id',
      dataIndex: 'r_song_id',
      key: 'r_song_id',
      ellipsis: true,
      width: '10%',
      render: (text: any, record: any, index: any) => {
        return <div>{text}</div>;
      },
    },
    {
      title: 'Song of the day',
      dataIndex: 'song_of_the_day',
      key: 'song_of_the_day',
      ellipsis: true,
      width: '10%',
      render: (text: any, record: any, index: any) => {
        return <div>{text ? 'Yes' : 'No'}</div>;
      },
    },
  ];
  return (
    <div className="padding-left">
      <Table
        columns={dataColumn}
        dataSource={record?.content?.items}
        pagination={false}
        scroll={{ y: 240 }}
      ></Table>
    </div>
  );
};
export default HeroSongDataTable;
